module.exports = __webpack_public_path__ + "img/20180815_145911_023.85fcf40d.jpg";